import React, { useRef } from 'react';
import { useNavigateAndScroll } from '../../Hooks/useNavigateAndScroll';

const SameDaySickVisits = () => {
  const barRef = useRef(null);
  const navigateAndScroll = useNavigateAndScroll();
  const infoCardsData = {
    expectantParents: {
      image: "https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/expectant_parents.webp",
      infoTitle: "Expectant Parents",
      infoText: "Comprehensive prenatal care, guidance, and support for expecting mothers and families preparing for their new arrival.",
      path: "/services/expectant-parents"
    },
    wellChecks: {
      image: "https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Well+Check.webp",
      infoTitle: "Well Checks", 
      infoText: "Regular preventive care appointments to monitor your child's growth, development, and overall health at every stage.",
      path: "/services/well-checks"
    },
    sameDaySickVisits: {
      image: "https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/sick+same+day.webp",
      infoTitle: "Same Day Sick Visits",
      infoText: "Prompt medical attention for acute illnesses and urgent health concerns when your child needs immediate care.",
      path: "/services/same-day-sick-visits"
    },
    functionalMedicine: {
      image: "https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Functional+Medicine.webp",
      infoTitle: "Functional Medicine",
      infoText: "Holistic approach to healthcare focusing on identifying and addressing the root causes of health issues for optimal wellness.",
      path: "/services/functional-medicine"
    },
    commonMedicalConditions: {
      image: "https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/common+medical+conditions.webp",
      infoTitle: "Common Medical Conditions",
      infoText: "Information and treatment options for frequently encountered pediatric and family health conditions and concerns.",
      path: "/services/common-medical-conditions"
    }
  };
  return (
    <div>
    <div className="relative w-auto z-1 mt-[-70px]">
          <img
            className="w-full h-auto rounded-lg shadow-lg mt-2"
            src="https://cipa-website-forms.s3.us-east-2.amazonaws.com/same_day_sick_InPixio.webp"
            alt="Mother and child meeting a doctor"
          />
        </div>
    <div ref={barRef} className="sticky top-0 flex justify-around bg-custom-blue text-white z-50">
        {Object.values(infoCardsData).map((card) => (
          <button
            key={card.infoTitle}
            className="p-1 text-sm cursor-pointer grow-text"
            onClick={() => navigateAndScroll(card.path, card.infoTitle)}
          >
            {card.infoTitle}
          </button>
        ))}
      </div>
    <div className="w-full px-4 py-8 sm:px-6 lg:px-64">
      <h2 className="text-4xl font-bold text-gray-800 mb-2">Same-Day Sick Visits</h2>
      <hr className="border-t-2 border-blue-500 mb-6" />

      <div className="space-y-6">
        <section>
          <p className="mb-4 text-gray-600">
            At <span className="font-semibold">Central Illinois Pediatric Associates</span>, we understand that waiting for care is not an option when your child is unwell. That's why we proudly offer <span className="font-semibold">same-day sick visits</span>, ensuring your child receives timely medical attention when they need it most. Designed for unexpected illnesses, these visits provide prompt care to address symptoms and ease discomfort.
          </p>
        </section>

        <section>
          <p className="mb-4 text-gray-600">
            When your child isn't feeling well, same-day sick visits offer the immediate care they need. Whether your child wakes up with a high fever and persistent cough or your child's daycare or school has called you to pick them up, our same-day sick visits provide prompt medical attention without the long wait. Issues such as <span className="font-semibold">earaches, sore throats, difficulty breathing, rashes,</span> or <span className="font-semibold">stomach discomfort</span> all require timely evaluation.
          </p>
        </section>

        <section>
          <p className="mb-4 text-gray-600">
            With our pediatricians just a phone call away, we are here to make a meaningful difference in your child's comfort and well-being.
          </p>
          <p className="mb-4 text-gray-600">
            Please explore our website to learn more about the conditions we treat and the services we offer.
          </p>
        </section>

        <section>
          <h3 className="text-2xl font-bold text-gray-800 mb-2">Is Your Child Feeling Unwell?</h3>
          <p className="text-gray-600">
            To help them get back to their daily activities, schedule a same-day sick visit by{' '}
            <a href="tel:+13096631011" className="text-blue-500 hover:underline">
              calling (309) 663-1011
            </a>{' '}
            or{' '}
            <a href="/schedule-sick-visit" className="text-blue-500 hover:underline">
              clicking here
            </a>.
          </p>
        </section>
      </div>
    </div>
    </div>
  );
};

export default SameDaySickVisits;
